<template>
  <div>
    <LoadingOverlay
      :hasBlur="false"
      isLight
      :visible="showLoader"
    />
    <GoogleEmmWelcome
      v-if="!isGoogleEmmEnrolled"
      @enrollmentComplete="handleEnrollmentComplete"
    />
    <GoogleEmmRegistration
      v-else
      :clientId="clientId"
      :contactEmail="contactEmail"
      :createdAt="createdAt"
      :enterpriseName="enterpriseName"
    />
  </div>
</template>

<script>
import {
  ItemTypeConsts, StoreModuleMap,
} from 'client/util/Constants';
import {
  LoadingOverlay,
} from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import GoogleEmmRegistration from 'client/MDM/GoogleEmmRegistration';
import GoogleEmmWelcome from 'client/MDM/GoogleEmmWelcome';

const googleModule = StoreModuleMap[ItemTypeConsts.mdmGoogle];
const moment = require('moment');

export default {
  name: 'GoogleSettingsMainPanel',

  components: {
    GoogleEmmRegistration,
    GoogleEmmWelcome,
    LoadingOverlay,
  },

  data: () => ({
    clientId: '',
    contactEmail: '',
    createdAt: '',
    enterpriseName: '',
    enterpriseRspBody: '',
    objectId: '',
    organizationObjectId: '',
    showLoader: true,
  }),

  computed: {
    ...mapState(googleModule, [
      'isGoogleEmmEnrolled',
    ]),
  },

  created() {
    this.fetchEnrollment();
  },

  methods: {
    ...mapActions(googleModule, [
      'getEnterprise',
      'updateEnrollState',
      'updateGoogleEmmEnterpriseObjState',
    ]),

    async fetchEnrollment() {
      try {
        const enterpriseResponse = await this.getEnterprise();
        if (enterpriseResponse.count > 0) {
          const resIndex = enterpriseResponse.count - 1;
          const [, clientId] = enterpriseResponse.enterprises[resIndex].name.split('/');
          this.enterpriseRspBody = {
            clientId,
            enterpriseEmail: '',
            createdAt: moment(enterpriseResponse.enterprises[resIndex].createdAt).format('MMMM d, YYYY, h:mm A'),
            enterpriseName: enterpriseResponse.enterprises[resIndex].displayName,
            enterpriseObjectId: enterpriseResponse.enterprises[resIndex].objectId,
            organizationObjectId: enterpriseResponse.enterprises[resIndex].organizationObjectId,
            allowDeviceEnrollment: enterpriseResponse.enterprises[resIndex].allowDeviceEnrollment
              ? enterpriseResponse.enterprises[resIndex].allowDeviceEnrollment
              : false,
            deviceGroupId: enterpriseResponse.enterprises[resIndex].deviceGroupId
              ? enterpriseResponse.enterprises[resIndex].deviceGroupId
              : '',
          };
          this.updateGoogleEmmEnterpriseObjState(this.enterpriseRspBody);
          this.updateEnrollState(true);
        }
      } catch (e) {
        this.updateEnrollState(false);
      }
      this.showLoader = false;
    },

    handleEnrollmentComplete() {
      this.fetchEnrollment();
    },
  },
};
</script>
